import { Component, forwardRef, Input, OnChanges, SimpleChanges } from '@angular/core';
import { FormBuilder, NG_VALIDATORS, NG_VALUE_ACCESSOR } from '@angular/forms';
import {
  CvaFormGroupComponent,
  ResetOptions
} from '@liberty-financial/agp-shared';
import { GuidUtil } from '@liberty-financial/ng-core';

import { ContactReferrerArrangement } from '@features/contacts/models/referrer-arrangement';

interface ReferrerArrangementForm {
  available: boolean;
  value: ContactReferrerArrangement.Model | null;
}

@Component({
  selector: 'spark-contacts-referrer-arrangement',
  templateUrl: './referrer-arrangement.component.html',
  providers: [
    {
      provide: NG_VALUE_ACCESSOR,
      useExisting: forwardRef(() => ContactsReferrerArrangementComponent),
      multi: true
    },
    {
      provide: NG_VALIDATORS,
      useExisting: forwardRef(() => ContactsReferrerArrangementComponent),
      multi: true
    }
  ]
})
export class ContactsReferrerArrangementComponent 
  extends CvaFormGroupComponent<
    ContactReferrerArrangement.Model | null,
    ReferrerArrangementForm
  >
  implements OnChanges {
  @Input() identifier = GuidUtil.generate();
  @Input()
  schema!: ContactReferrerArrangement.SchemaPropertyDefinition;
  @Input() isDisabled = false;
  
  form = this.fb.group({
    available: this.fb.nonNullable.control<boolean>(false),
    value: this.fb.control<ContactReferrerArrangement.Model | null>(null)
  });
  upfrontType = ContactReferrerArrangement.UpfrontType;

  constructor(private readonly fb: FormBuilder) {
    super();
  }

  ngOnChanges(changes: SimpleChanges): void {
    if (changes['isDisabled']) {
      if (this.isDisabled) {
        this.form.disable({ emitEvent: false });
      } else {
        this.form.enable({ emitEvent: false });
      }
    }
  }

  protected reset(opts?: ResetOptions | undefined): void {
    this.form.reset(undefined, opts);
  }

  transformToModel = (
    value: ReferrerArrangementForm
  ): ContactReferrerArrangement.Model | null =>
    value.available ? value.value : null;

  transformToForm = (
    value: ContactReferrerArrangement.Model | null
  ): ReferrerArrangementForm =>
    value
      ? {
          available: true,
          value: value
        }
      : {
          available: false,
          value: null
        };
}
